import { token } from '@atlaskit/tokens';

import { createEffect } from '../utils/create-effect';

import {
  HIGHLIGHT_DELETE_INTENT_CLASS,
  SELECTION_HIGHLIGHT_CLASS,
  SELECTIONS_CONTAINER_ELEMENT_ID,
} from './constants';

const STYLES_ID = 'selections-delete-intent-styles';

function getDeleteIntentStyles(): string {
  const dangerBorder = token('color.border.danger', '#E34935');
  const dangerBackground = token('color.background.danger.hovered', '#FFD5D2');

  return `
    #${SELECTIONS_CONTAINER_ELEMENT_ID}.${HIGHLIGHT_DELETE_INTENT_CLASS} .${SELECTION_HIGHLIGHT_CLASS} {
      border-color: ${dangerBorder} !important;
      background: color-mix(in srgb, ${dangerBackground} 25%, transparent) !important;
      transition: border-color 0.2s, background 0.2s;
    }
  `;
}

function ensureStylesInjected(): void {
  if (document.getElementById(STYLES_ID)) {
    return;
  }

  const styleElement = document.createElement('style');

  styleElement.id = STYLES_ID;
  styleElement.textContent = getDeleteIntentStyles();

  document.head.appendChild(styleElement);
}

function removeStyles(): void {
  document.getElementById(STYLES_ID)?.remove();
  document
    .getElementById(SELECTIONS_CONTAINER_ELEMENT_ID)
    ?.classList.remove(HIGHLIGHT_DELETE_INTENT_CLASS);
}

/**
 * Effect that adds/removes the delete intent class on the selections container
 * when a preview delete action is signaled. This changes highlight colors to red.
 */
export const createDeleteIntentHighlightEffect = createEffect(() => ({
  deltaTypes: ['previewSelectionAction'] as const,

  setup() {
    ensureStylesInjected();
  },

  dispose() {
    removeStyles();
  },

  onDelta(delta) {
    const container = document.getElementById(SELECTIONS_CONTAINER_ELEMENT_ID);

    if (!container) {
      return;
    }

    if (delta.intent === 'delete') {
      container.classList.add(HIGHLIGHT_DELETE_INTENT_CLASS);
    } else {
      container.classList.remove(HIGHLIGHT_DELETE_INTENT_CLASS);
    }
  },
}));
